import { Location } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HLong } from '@shared/src/datatypes/HLong';
import { HomeController, HString, SecurityController, SharedBookingHeaderComponent } from '@shared/src/public-api';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { BookingSlotChangeReasonActionTypes } from '@shared/src/enums/BookingSlotChangeReasonActionTypes';
import { BookingSlotChangeReasonDataInfoDto } from '@shared/src/dtos/booking/slotchangereason/BookingSlotChangeReasonDataInfoDto';
import { BookingDto } from '@shared/src/dtos/booking/BookingDto';
import { iBookingExpand } from '@shared/src/dtos/booking/iBookingExpand';
import { iBooking } from '@shared/src/dtos/booking/iBooking';
import { fadeInOut } from '@shared/src/animations';

@Component({
  selector: 'shared-active-bookings-item',
  templateUrl: './shared.active.bookings.item.html',
  styleUrls: ['./shared.active.bookings.item.scss'],
  animations: [fadeInOut]
})
export class SharedActiveBookingsItem implements OnInit {

  public allLoaded: boolean = false;
  public useIonic: boolean = false;

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('bookingHeader') bookingHeader!: SharedBookingHeaderComponent;

  constructor(public activatedRoute: ActivatedRoute,
    public router: Router, public location: Location, protected bookingController: BookingController,
    @Inject('SecurityController') protected securityController: SecurityController,
    @Inject('HomeController') public homeController: HomeController) {

    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();

    //Fem subscribe per detectar només el location.back i location.forward que s'executen  només al anar endevant i enrera en els botons del navegador
    //Nomes ho fem amb aquests dos casos ja que o sinó esta constantment detectant canvis al canviar els parametres de url en el routeTo
    this.location.subscribe(
      ((value: PopStateEvent) => {
        console.log(value);
        this.loadParametersLocation();
      }),
      (ex => {
      })
    );
  }
  public loadParametersLocation() {

    let path = this.location.path();
    if (path == "")
      return;

    let tree = this.router.parseUrl(path);
    let queryParams = tree.queryParams;

    let pp = BookingController.PARAMETERACTIONNAME;
    let action = queryParams[BookingController.PARAMETERACTIONNAME];
    if (action)
      this.actionId = action;

    if (!HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME)) {
      let option = queryParams[BookingController.PARAMETEROPTIONNAME];
      if (option)
        this._selectedOptionId = option;
    } else
      this._selectedOptionId = "";

    this.allLoaded = true;
  }
  routeTo() {
    if (!this.allLoaded || this.useIonic)
      return;

    if (!HString.startsWith(this.router.url, "/operation/booking"))
      return;

    let object = { ...this.activatedRoute.snapshot.queryParams };

    if (!HString.isNullOrNullString(this.actionId))
      object[BookingController.PARAMETERACTIONNAME] = this.actionId;
    else
      delete object[BookingController.PARAMETERACTIONNAME];

    if (!HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME)) {
      if (!HString.isNullOrNullString(this.selectedOptionId))
        object[BookingController.PARAMETEROPTIONNAME] = this.selectedOptionId;
      else
        delete object[BookingController.PARAMETEROPTIONNAME];
    }

    //Aqui no estem rederigint, només estem actualtzant els queryParams perque es vegi reflectida la URL. 
    //Al no redirigir (que ja es el que volem perquè no es necessàri), no està refrescant la pagina i no entrarà pel ngOnInit()
    this.router.navigate([".", {}], { relativeTo: this.activatedRoute, queryParams: object, queryParamsHandling: '' });
  }

  @Input() public readonly: boolean;

  @Output() clickBack = new EventEmitter<boolean>();
  @Output() saveNewBooking = new EventEmitter<iBooking>();

  public _bookingId: number;
  @Input()
  public get bookingId(): number {
    return this._bookingId;
  }
  public set bookingId(value: number) {
    if (this._bookingId === value)
      return;
    this._bookingId = value;
    this.routeTo();
    this.loadData();
  }

  public _selectedBooking: iBookingExpand;
  public get selectedBooking(): iBookingExpand {
    return this._selectedBooking;
  }
  public set selectedBooking(value: iBookingExpand) {
    if (this._selectedBooking === value)
      return;

    const firstSelect = this._selectedBooking == null || value == null || value.bookingId == null;

    this._selectedBooking = value;
    this.bookingId = value != null ? value.bookingId : 0;

    this.getOptions(firstSelect);
    this.loadActions();

  }

  public _selectedRoute: RouteCardItemDto;
  public get selectedRoute(): RouteCardItemDto {
    return this._selectedRoute;
  }
  public set selectedRoute(value: RouteCardItemDto) {
    if (this._selectedRoute === value)
      return;

    this._selectedRoute = value;
  }

  onSelectRouteChange(value: RouteCardItemDto) {
    this.selectedRoute = value;
    if (this.selectedRoute)
      this.bookingHeader.expanded = false;
    else
      this.bookingHeader.expanded = true;
  }

  public _actionId: string;
  @Input()
  public get actionId(): string {
    return this._actionId;
  }
  public set actionId(value: string) {
    if (this._actionId === value)
      return;
    this._actionId = value;
    if (HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME)) {
      this.selectedBooking = new BookingDto();
      this._selectedOptionId = "";
    }
    this.routeTo();
  }

  public _selectedOptionId: string;
  public get selectedOptionId(): string {
    return this._selectedOptionId;
  }
  public set selectedOptionId(value: string) {
    if (this._selectedOptionId === value)
      return;
    this._selectedOptionId = value;
    this.routeTo();
  }


  public options: OptionsStripDto;

  public getOptions(goToActiveTab: boolean) {

    if (HLong.isNullOrNullLong(this.bookingId))
      return;

    if (this.selectedRoute != null)
      return;

    let actualOptionId: OptionDto = null;
    if (this.options)
      actualOptionId = this.options.getActualSelected();

    this.bookingController.getOptions(this.bookingId).subscribe(e => {
      this.options = OptionsStripDto.buildFromOptionsStripDto(e);
      if (goToActiveTab && this.options.getActualSelected()) {
        this.selectOptionId(this.options.getActualSelected().optionId);
      } else if (actualOptionId) {
        this.selectOptionId(actualOptionId.optionId);
      }
    });
  }

  public selectOptionId(optionId: string) {
    if (optionId) {
      OptionsStripDto.selectById(this.options, optionId);
      this.selectedOptionId = this.options.getActualSelected().optionId;
    }
  }

  public onClickOption(option: OptionDto) {
    if (option)
      this.selectedOptionId = option.optionId;
    this.clearAction();
  }
  clearAction() {
    this.actionId = "";
  }

  onClickBack(event) {
    if (HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME))
      this.actionId = "";
    this.resetScroll();
    this.clickBack.next(true);
  }

  ngOnInit(): void {
    this.loadParametersLocation();
  }

  public actions: ActionsStripDto;
  public loadActions() {
    if (this.selectedBooking == null || HLong.isNullOrNullLong(this.selectedBooking.bookingId)) {
      this.actions = null;
      return;
    }

    this.bookingController.getActions(this.selectedBooking.bookingId).subscribe(e => {
      this.actions = ActionsStripDto.buildFromActionsStripDto(e);
    })
  }

  public onSave(e: iBookingExpand) {
    if (!e)
      return;

    if (HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME)) {
      this.actionId = "";
      //Necessitem resetejar el seleccionat perque es seleccioni tot be
      this._selectedBooking = null;
      this.saveNewBooking.next(e);
      return;
    }
    this._selectedBooking = e;
    this.onReloadBooking(true);
  }

  resetScroll() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollTop = 0;
      if (this.scrollContainer.nativeElement.parentElement != null)
        this.scrollContainer.nativeElement.parentElement.scrollTop = 0;
    }
  }

  public loadData() {

    if (HLong.isNullOrNullLong(this.bookingId)) {
      if (!HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME))
        this.selectedBooking = null;
      return;
    }
    this.bookingController.getBookingCardItemExpand(this.bookingId).subscribe(data => {
      this.selectedBooking = data;
      this.wellCome();
    });
  }

  public onReloadBooking(value: boolean) {
    if (!value)
      return;
    if (this.selectedBooking != null && !HLong.isNullOrNullLong(this.selectedBooking.bookingId)) {
      this.bookingController.getBookingCardItemExpand(this.selectedBooking.bookingId).subscribe(e => {
        this._selectedBooking = e;
        this.getOptions(true);
        this.wellCome();
      });
    }
  }


  public calculateReadOnly() {
    this.securityController.getStoredUserDto().subscribe(data => {
      this.readonly = data.isReadOnly || (this.selectedBooking && !HLong.isNullOrNullLong(this.selectedBooking.bookingId) && !this.selectedBooking.isModifiable);
    })
  }

  public onBookingStateChange($event: any) {
    this.onReloadBooking(true);
  }
  public onFinishAddRoutes(value: boolean) {
    if (!value)
      return;
    this.onReloadBooking(value);
  }

  public onFinishRemoveRoutes(value: boolean) {
    if (!value)
      return;
    this.onReloadBooking(value);
  }

  public onFinishConflictRoutes(value: boolean) {
    if (!value)
      return;
    this.onReloadBooking(value);
  }

  public wellCome() {
    this.clearAction();
    this.calculateReadOnly();
    if (this.selectedBooking != null && !HLong.isNullOrNullLong(this.selectedBooking.bookingId) && HString.equals(this.actionId, BookingController.ACTION_ADD_BOOKING_NAME))
      this.actionId = "";
  }


  public onClickAction(action: ActionDto) {
    this.clearAction();
    switch (action.actionId) {
      case "ADD":
        break;
      case "COPY":
        if (this.selectedBooking && !HLong.isNullOrNullLong(this.selectedBooking.bookingId))
          this.bookingController.cloneBooking(this.selectedBooking.bookingId).subscribe(e => {
            if (e && e.bookingId) {
              this.selectedBooking = e;
            }
          });
        break;
      case "DELETE":
        this.actionId = action.actionId;
        break;
      case "CANCELALL":
        if (this.selectedBooking && !HLong.isNullOrNullLong(this.selectedBooking.bookingId)) {
          this.bookingController.getRequiredSlotChangeReason(this.selectedBooking.bookingId, BookingSlotChangeReasonActionTypes.CancelAllSlot).subscribe((data: boolean) => {
            if (data) {
              this.homeController.openAsideBookingSlotChangeReasonManage(this.selectedBooking.bookingId, BookingSlotChangeReasonDataInfoDto.buildCancelAllSlot(this.selectedBooking.bookingId)).then(value => {
                if (value) {
                  this.onReloadBooking(true);
                }
              });
            } else {
              this.bookingController.executeAction(this.selectedBooking.bookingId, action).subscribe(e => {
                if (e) {
                  this.onReloadBooking(true);
                }
              });
            }
          });
        }
        break;
      default:
        if (this.selectedBooking && !HLong.isNullOrNullLong(this.selectedBooking.bookingId))
          this.bookingController.executeAction(this.selectedBooking.bookingId, action).subscribe(e => {
            if (e) {
              this.onReloadBooking(true);
            }
          });
        break;
    }
  }

  public onDelete($event: any) {
    if (this.selectedBooking && !HLong.isNullOrNullLong(this.selectedBooking.bookingId))
      this.bookingController.deleteBooking(this.selectedBooking.bookingId).subscribe(e => {
        if (e) {
          this.selectedBooking = undefined;
          this.onClickBack(true);
        }
      });
  }

  public onCancelDelete($event: any) {
    this.actionId = "";
  }
}
